<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container>
    <h4>Page not found</h4>
    <h6>Error 404</h6>
  </v-container>
</template>

<script>
export default {
  name: 'error404',
};
</script>

<style lang="scss" scoped>
</style>
